import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';

export interface ExportNoticeData {
    /** Offer an optional password that protects the exported file. */
    passwordOption?: boolean;
}

export interface ExportNoticeResult {
    /** Set when the user chose a password to protect the file. */
    password?: string;
}

export const EXPORT_PASSWORD_MIN_LENGTH = 8;

/**
 * Shown before personal data leaves the app as a file (BSI TR-03161-2 O.Data_1, O.Data_2): tells the
 * user that they are responsible for the exported data and, for PDF reports, offers a password.
 */
@Component({
    selector: 'export-notice-dialog',
    imports: [MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, FormsModule, TranslocoModule],
    templateUrl: './export-notice-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class ExportNoticeDialogComponent {
    data: ExportNoticeData = inject(MAT_DIALOG_DATA) ?? {};
    password = '';

    private _dialogRef = inject(MatDialogRef<ExportNoticeDialogComponent, ExportNoticeResult | null>);

    readonly minLength = EXPORT_PASSWORD_MIN_LENGTH;

    get passwordTooShort(): boolean {
        return this.password.length > 0 && this.password.length < this.minLength;
    }

    confirm(): void {
        if (this.passwordTooShort) {
            return;
        }
        const result: ExportNoticeResult = this.password ? { password: this.password } : {};
        this._dialogRef.close(result);
    }
}
